var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.content.category === 'withBefore')?_c('withBefore',{attrs:{"content":_vm.content}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }